// Las piezas compartidas del panel de herramientas del visor (EdicionEnElVisor y los
// modos que viven en su propio archivo, como ModoCapas).

import { useLayoutEffect, useState, type ReactNode, type RefObject } from 'react';

// ── Piezas del panel ────────────────────────────────────────────────────────────

/** Sección agrupada (el "iOS grouped" de los menús, en oscuro). */
export const Seccion: React.FC<{ titulo: string; children: ReactNode; className?: string }> = ({ titulo, children, className = '' }) => (
  <section className={className}>
    <p className="mb-2 text-[11.5px] font-medium uppercase tracking-wide text-white/40">{titulo}</p>
    <div className="overflow-hidden rounded-[13px] border border-white/[0.07] bg-white/[0.05]">{children}</div>
  </section>
);

export const Pie: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className="flex shrink-0 items-center justify-end gap-2 border-t border-white/[0.07] px-4 py-3">{children}</div>
);

export const Cuerpo: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className="min-h-0 flex-1 space-y-5 overflow-y-auto px-4 py-4 scrollbar-hide">{children}</div>
);

/** Una capa fija calzada sobre un elemento del visor (la `<img>`, o su área en el teléfono). */
export function useCalceSobre(imgRef: RefObject<HTMLElement>, activo: boolean) {
  const [rect, setRect] = useState<{ left: number; top: number; width: number; height: number } | null>(null);
  useLayoutEffect(() => {
    if (!activo) return;
    const calzar = () => {
      const r = imgRef.current?.getBoundingClientRect();
      if (r) setRect({ left: r.left, top: r.top, width: r.width, height: r.height });
    };
    calzar();
    window.addEventListener('resize', calzar);
    // También cuando la imagen cambia de tamaño sin que cambie la ventana: en el teléfono la
    // caja del prompt se va al abrir una herramienta y la imagen crece
    // (ADR-2026-10-28-editar-en-el-visor-del-celular).
    const img = imgRef.current;
    const ro = img ? new ResizeObserver(calzar) : null;
    if (img) ro?.observe(img);
    return () => {
      window.removeEventListener('resize', calzar);
      ro?.disconnect();
    };
  }, [imgRef, activo]);
  return rect;
}
